/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
 */
export interface GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'colorGradation'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'heightMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarnings
     */
    'widthMillis'?: GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsDetectedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsColorGradationEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsHeightMillisEnum];
export const GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum = typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetCardTransactions200ResponseMergedTransactionDetailListInnerEvidenceListInnerWarningsWidthMillisEnum];


